import React from 'react';
import propTypes from 'prop-types';
import Modal from 'tailwind-components/Modal/Modal';

export default function UntappedStatesModal({
  active,
  carrierName,
  states = [],
  onClose
}) {
  const count = states.length;
  const stateLabel = count === 1 ? 'state' : 'states';

  return (
    <Modal
      active={active}
      closeModal={onClose}
      title={carrierName ? `Available states — ${carrierName}` : 'Available states'}
      size='medium'
      hideFooter
      showScrollbar
    >
      <div className='flex flex-col gap-4'>
        <p className='m-0 text-sm text-grey'>
          {count} {stateLabel} where this agent is licensed for this carrier.
        </p>
        <ul className='m-0 flex list-none flex-wrap gap-2 p-0'>
          {states.map(state => (
            <li
              key={state}
              className='rounded-full border border-grey-lighter bg-grey-background px-3 py-1.5 text-sm text-gray-800'
            >
              {state}
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  );
}

UntappedStatesModal.propTypes = {
  active: propTypes.bool.isRequired,
  carrierName: propTypes.string,
  states: propTypes.arrayOf(propTypes.string),
  onClose: propTypes.func.isRequired
};
